import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SocialDistanceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"social_distance"}/>
}
